import React, { useEffect, useState } from 'react';
import { motion } from 'framer-motion';
export function Nav() {
  const [isScrolled, setIsScrolled] = useState(false);
  useEffect(() => {
    const handleScroll = () => {
      setIsScrolled(window.scrollY > 20);
    };
    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);
  const scrollToSection = (id: string) => {
    const element = document.getElementById(id);
    if (element) {
      element.scrollIntoView({
        behavior: 'smooth'
      });
    }
  };
  return <motion.nav initial={{
    y: -100
  }} animate={{
    y: 0
  }} className={`fixed top-0 left-0 right-0 z-50 transition-all duration-300 ${isScrolled ? 'bg-[#0a0a0a]/95 backdrop-blur-sm border-b border-[#8b1a1a]/20' : 'bg-transparent'}`} data-id="element-224">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-225">
        <div className="flex items-center justify-between h-20" data-id="element-226">
          <div className="flex items-center space-x-3" data-id="element-227">
            <img src="https://cdn.magicpatterns.com/uploads/qVSgAWpQyG1QENGutcuqdx/ChatGPT_Image_21_jun_2026,_22_59_42.png" alt="UnsolvedNights logo" className="h-12 w-12 object-contain" data-id="element-228" />
            <span className="font-typewriter text-xl text-[#ece3d0]" data-id="element-229">
              UnsolvedNights
            </span>
          </div>

          <div className="hidden md:flex items-center space-x-8" data-id="element-230">
            <button onClick={() => scrollToSection('collection')} className="text-[#ece3d0]/80 hover:text-[#ece3d0] transition-colors text-sm" data-id="element-231">
              The Collection
            </button>
            <button onClick={() => scrollToSection('how-it-works')} className="text-[#ece3d0]/80 hover:text-[#ece3d0] transition-colors text-sm" data-id="element-232">
              How It Works
            </button>
            <button onClick={() => scrollToSection('reviews')} className="text-[#ece3d0]/80 hover:text-[#ece3d0] transition-colors text-sm" data-id="element-233">
              Reviews
            </button>
            <button onClick={() => scrollToSection('bundle')} className="bg-[#8b1a1a] hover:bg-[#a01f1f] text-[#ece3d0] px-6 py-2 rounded font-medium transition-colors text-sm" data-id="element-234">
              Get the Collection
            </button>
          </div>
        </div>
      </div>
    </motion.nav>;
}